/**
 * rd-bookings — the shared 44×44 glass back button used across the shipped flow
 * pages (session detail / details / payment / confirmation) and the Bookings-tab
 * header. Visual-only: it owns the glass square + arrow glyph; POSITIONING stays
 * with each consumer via `className` (the flow pages are `position: fixed` under
 * the TG safe-area; the tab's sits in the header slot). Extracted from the
 * replicated `.back` CSS (PaymentPage.module.css et al.) per design D6.
 */
import { BackIcon } from '@/pages/BookSessionPage/catalogIcons';
import styles from './FlowBackButton.module.css';

export interface FlowBackButtonProps {
  onClick: () => void;
  disabled?: boolean;
  /** Consumer-owned positioning (fixed/absolute + offsets). */
  className?: string;
}

export function FlowBackButton({ onClick, disabled, className }: FlowBackButtonProps) {
  return (
    <button
      type="button"
      className={className ? `${styles.back} ${className}` : styles.back}
      onClick={onClick}
      disabled={disabled}
      aria-label="Back"
    >
      {BackIcon}
    </button>
  );
}
